import { useEffect, useState } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#service", label: "サービス" },
    { href: "#feature", label: "特徴" },
    { href: "#plan", label: "料金プラン" },
    { href: "#schedule", label: "試合日程" },
    { href: "#parking", label: "空き状況" },
    { href: "#flow", label: "ご利用の流れ" },
    { href: "#access", label: "アクセス" },
    { href: "#faq", label: "よくある質問" },
  ];

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center cursor-pointer">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-full -translate-x-[4.8px] -translate-y-[6.4px] md:translate-x-0 md:translate-y-0 ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-parking-box-fill text-lg" />
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l, i) => (
            <div key={l.href} className="flex items-center">
              <a
                href={l.href}
                className={`px-3 py-2 text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  scrolled
                    ? "text-foreground-800 hover:text-primary-600"
                    : "text-background-50 hover:text-secondary-200"
                }`}
              >
                {l.label}
              </a>
              {i < links.length - 1 && (
                <span
                  className={`text-[10px] ${
                    scrolled ? "text-foreground-300" : "text-background-100/70"
                  }`}
                >
                  ◆
                </span>
              )}
            </div>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#reserve"
            className="hidden md:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full px-5 py-2.5 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-calendar-check-line" />
            今すぐ予約する
          </a>
          <button
            aria-label="menu"
            onClick={() => setMobileOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
              scrolled ? "text-foreground-950 bg-background-100" : "text-background-50 bg-background-50/10"
            }`}
          >
            <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-6 py-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMobileOpen(false)}
              className="block py-3 text-foreground-800 text-sm border-b border-background-100 cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}